import * as React from 'react';

var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgPolarized = function SvgPolarized(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 38.5c10.217 0 18.5-8.283 18.5-18.5S30.217 1.5 20 1.5 1.5 9.783 1.5 20 9.783 38.5 20 38.5ZM40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.75 15.5a2.25 2.25 0 0 0-2.25 2.25v1.5c0 2.9 2.35 5.25 5.25 5.25h1.782c.39-.002.75-.201.96-.526l1.088-3.699a1.499 1.499 0 0 1 2.839 0l1.09 3.699c.21.325.57.524.96.526h1.781c2.9 0 5.25-2.35 5.25-5.25v-1.5a2.25 2.25 0 0 0-2.25-2.25h-16.5ZM8 17.75A3.75 3.75 0 0 1 11.75 14h16.5A3.75 3.75 0 0 1 32 17.75v1.5A6.75 6.75 0 0 1 25.25 26h-1.785a2.65 2.65 0 0 1-2.304-1.358.745.745 0 0 1-.064-.154L20 20.765l-1.096 3.723a.747.747 0 0 1-.064.154A2.65 2.65 0 0 1 16.537 26H14.75A6.75 6.75 0 0 1 8 19.25v-1.5Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 17.75a.75.75 0 0 1 .75-.75h22.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1-.75-.75ZM8.19 20.75a.75.75 0 0 1 .75-.75h10.28a.75.75 0 0 1 0 1.5H8.94a.75.75 0 0 1-.75-.75ZM20.03 20.75a.75.75 0 0 1 .75-.75h10.28a.75.75 0 0 1 0 1.5H20.78a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  })));
};

export { SvgPolarized as default };
//# sourceMappingURL=polarized.svg.js.map
